import React from 'react'
import ContentWidth  from './ContentWidth'
import styled from 'styled-components'
import colors from '../styles/colors'
import media from '../styles/media'


const SectionHeading = ({ content }) => {
  return (
    <ContentWidth>
        <HeadingContainer>
          <Heading dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
        </HeadingContainer>
    </ContentWidth>
  )
}

const HeadingContainer = styled.div`
  margin: 4.722vw auto -4.514vw  auto;
  

  ${media.fullWidth} {
    margin: 68px auto -65px auto;
  }
`

const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
  p {
    color: ${colors.grey700};
    font-weight: 700;
    font-family: Archivo, sans;
    font-size: 1.389vw;
    margin-bottom: 1.389vw;


    ${media.fullWidth} {
      font-size: 20px;
      margin-bottom: 20px;
    }
    
    ${media.tablet} {
      font-size: 31px;
      
    }
    
    ${media.mobile} {
      font-size: 4.673vw;
      margin-bottom: 4.673vw;
      width: 70%;
    }
  }

  p strong {
    font-family: Archivo;
    font-size: 4.206vw;
    line-height: 5.607vw;
    letter-spacing: 0.748vw;
    font-weight: 800;
    text-align: center;
    color: ${colors.grey800};

    ${media.fullWidth}{
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 3.2px;
    }
    ${media.tablet}{
      font-size: 1.758vw;
      line-height: 2.344vw;
      letter-spacing: 0.313vw;
    }
    ${media.mobile}{
      font-size: 3.738vw;
      line-height: 4.673vw;
      letter-spacing:0.701vw;
    }
  }

  h2 {
  font-weight: 700;
  font-family: Archivo, sans;
  font-size: 2.778vw;
  line-height: 3.333vw;
  margin-bottom: 1.111vw;

  ${media.fullWidth} {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 16px;
  }
  
  ${media.tablet} {
    font-size: 3.5vw;
    margin-bottom: 3.5vw;
  }
  
  ${media.mobile} {
    font-size: 7.009vw;
    line-height: 8.215vw;
    margin-bottom: 3.738vw;
  }
 }

  h3 {
    text-align: center;
    color: ${colors.grey700};
    font-family: Archivo, sans;
    font-weight: 700;
    font-size: 2.778vw;

    ${media.fullWidth} {
      font-size: 40px;
    }
    
    ${media.tablet} {
      font-size: 3.906vw;
    }
    
    ${media.mobile} {
      font-size: 9.346vw;
    }
  }
`

export default SectionHeading
